import { useTenant } from 'app/TenantValidator';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { isDefined, isNonNullish } from 'remeda';
import { useLoadCompanyConfiguration } from 'shared/hooks/use-load-company-configuration';

import { companyConfigurationAtom } from './use-company-configuration';

export function useEnforceCompanyConfiguration() {
  const tenant = useTenant();

  const [companyConfigurationFromAtom, setCompanyConfiguration] = useAtom(companyConfigurationAtom);

  const isOnboardingComplete = tenant?.onboarding.isComplete ?? false;

  const { company: companyConfiguration, companyError: companyConfigurationError } =
    useLoadCompanyConfiguration(isOnboardingComplete);

  useEffect(() => {
    if (isDefined(companyConfiguration)) setCompanyConfiguration(companyConfiguration);
  }, [companyConfiguration, setCompanyConfiguration]);

  const isCompanyConfigurationReady = (() => {
    if (!isDefined(tenant)) return false;
    if (!isOnboardingComplete) return true;
    return isNonNullish(companyConfigurationFromAtom);
  })();

  return { companyConfiguration, companyConfigurationError, isCompanyConfigurationReady };
}
